// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".hero-module-search {\n  margin: 1rem 0;\n}\n", "",{"version":3,"sources":["/home/jenkins/agent/workspace/helpcenter-release/client/src/components/search-bar/search-bar-v1.less","search-bar-v1.less"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF","file":"search-bar-v1.less","sourcesContent":[".hero-module-search {\n  margin: 1rem 0;\n}\n",".hero-module-search {\n  margin: 1rem 0;\n}\n"]}]);
// Exports
module.exports = exports;
